var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReceipt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 37,
    viewBox: "0 0 36 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 11V32C3 33.245 4.41 33.95 5.4 33.2L7.965 31.28C8.565 30.83 9.405 30.89 9.945 31.43L12.435 33.935C13.02 34.52 13.98 34.52 14.565 33.935L17.085 31.415C17.61 30.89 18.45 30.83 19.035 31.28L21.6 33.2C22.59 33.935 24 33.23 24 32V6.5C24 4.85 25.35 3.5 27 3.5H10.5H9C4.5 3.5 3 6.185 3 9.5V11Z",
    fill: "#3D3D3D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.015 3.5V5.75C28.005 5.75 28.95 6.155 29.64 6.83C30.36 7.565 30.75 8.51 30.75 9.5V13.13C30.75 14.24 30.255 14.75 29.13 14.75H26.25V6.515C26.25 6.095 26.595 5.75 27.015 5.75V3.5ZM27.015 3.5C25.35 3.5 24 4.85 24 6.515V17H29.13C31.5 17 33 15.5 33 13.13V9.5C33 7.85 32.325 6.35 31.245 5.255C30.15 4.175 28.665 3.515 27.015 3.5C27.03 3.5 27.015 3.5 27.015 3.5Z",
    fill: "#3D3D3D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReceipt);
export default __webpack_public_path__ + "static/media/receipt.a42e319d1287142686a441fdd78060f8.svg";
export { ForwardRef as ReactComponent };